export enum mainMenuTypes {
    Launchpad = 0,
    PasswordVaults = 1,
    SystemManager = 2,
        Tenants = 201,
        ScheduledJobs = 203,
        Notifications = 204,
    GettingStarted = 3,
    DirectoryManager = 4,
        Users = 401,
        Groups = 402,
        Roles = 403,
        Organizations = 404,
        DirectorySync = 405,
    PasswordServer = 5,
        PasswordReminders = 501,
        VaultManager = 502,
        PasswordPolicy = 503,
        Agents = 504,
        MigrateFromOnPremise = 505,
    PasswordManager2 = 12,
        PasswordReminders2 = 506,
        VaultManager2 = 507,
        PasswordPolicy2 = 508,
        Agents2 = 509,
        MigrateFromOnPremise2 = 510,
    JIT = 6,
        JITUsers = 601,
    AuthManager = 7,
        AuthManagerAgents = 701,
        Logs = 702,
        ApiExplorer = 703,
    PolicyManager = 8,
        Authentication = 801,
        Provisioning = 802,
    SSOManager = 9,
        ApplicationLibrary = 901,
        WorkflowRequests = 902,
        SystemCatalog = 903,
        WorkflowErrors = 904,
    LicenseManager = 10,
        LicenseAllocation = 1001,
    HelpSupport = 11,
    MyProfile = 9991,
    TestMfa = 9992,
    KaseyaOne = 56,
    IntegrationManager = 57,
        DarkwebCompromise = 58,
        Bullphish = 59,
    Reports = 61,
}
